import React from "react";
import {css} from "/src/utils/utils";

import * as styles from "./error.module.scss";

interface Props {
  message?: string;
  visible: boolean;
}

export default function ErrorMessage({message, visible}: Props) {
  const hasValidErrorMessage = message != null && message.trim() !== "";
  const showError = visible && hasValidErrorMessage;

  return showError ? (
    <p
      role={showError ? "alert" : "none"}
      aria-hidden={!showError}
      className={css(styles.error, "p")}
    >
      {message}
    </p>
  ) : (
    <div className={css(styles.error, styles.errorEmpty)}></div>
  );
}
